import { Link } from "react-router-dom";
import { company, nav } from "@/data/site";
import { TerminDialog } from "@/components/TerminDialog";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t hairline bg-[color:var(--bg)]">
    <div className="container-x pt-16 pb-28 md:pb-14">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <img src="/nivo-logo-white.png" alt="NIVO GARAGE – Ihre Garage mit Niveau – Reparatur aller Marken" width="744" height="390" loading="lazy" className="h-auto w-[200px] -ml-2" data-testid="footer-logo-image" />
          <p className="mt-6 text-[color:var(--ink-2)] max-w-sm">Service, Reparaturen und Diagnose für Fahrzeuge aller Marken in {company.city}.</p>
        </div>
        <div className="md:col-span-3">
          <p className="eyebrow mb-5">Navigation</p>
          <ul className="space-y-3">
            {[{ label: "Startseite", to: "/" }, ...nav].map((n) => (
              <li key={n.to}><Link to={n.to} className="text-[color:var(--ink-2)] hover:text-[color:var(--ink)] transition-colors link-underline">{n.label}</Link></li>
            ))}
            <li><TerminDialog testId="footer-appointment-link" className="text-[color:var(--ink-2)] hover:text-[color:var(--ink)] transition-colors link-underline" /></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="eyebrow mb-5">Kontakt</p>
          <address className="not-italic space-y-3 text-[color:var(--ink-2)]">
            <p className="text-[color:var(--ink)]">{company.legalName}</p>
            {company.confirmed.address ? (
              <p>{company.street}<br />{company.zip} {company.city}</p>
            ) : (
              <p>{company.region}</p>
            )}
            <a href={company.phoneHref} data-testid="footer-phone-link" className="block hover:text-[color:var(--ink)] transition-colors">{company.phone}</a>
            {company.confirmed.email && (
              <a href={`mailto:${company.email}`} data-testid="footer-email-link" className="block hover:text-[color:var(--ink)] transition-colors">{company.email}</a>
            )}
            <p className="text-[14px] text-[color:var(--ink-3)]">{company.hoursNote}</p>
          </address>
        </div>
      </div>
      <div className="mt-14 pt-6 border-t hairline flex flex-col md:flex-row justify-between gap-4 text-[13px] text-[color:var(--ink-3)]">
        <p>© {new Date().getFullYear()} {company.legalName}. Alle Rechte vorbehalten.</p>
        <div className="flex gap-6">
          <Link to="/impressum" data-testid="footer-impressum-link" className="hover:text-[color:var(--ink)] transition-colors">Impressum</Link>
          <Link to="/datenschutz" data-testid="footer-datenschutz-link" className="hover:text-[color:var(--ink)] transition-colors">Datenschutz</Link>
          <Link to="/agb" data-testid="footer-agb-link" className="hover:text-[color:var(--ink)] transition-colors">AGB</Link>
        </div>
      </div>
    </div>
  </footer>
);
